import { PaymentType } from "api/models";
import { KeyTitlePair } from "shared/types";

export const PAYMENT_TYPES: KeyTitlePair[] = [
  { key: PaymentType.FLAT, title: "Flat" },
  { key: PaymentType.PROVISION, title: "Provision" }
];
